import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Api } from '../../providers/api';
import {CartPage} from "../cart/cart";
import {GVLogger} from "../../services/gv-logger";
/*
  Generated class for the CustomerDetail page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-customer-detail',
  templateUrl: 'customer-detail.html'
})
export class CustomerDetailPage {
	customerId: any;
	customerDetail : {
	id: 1
      customerId: "1101111110",
      name: "Bargain Mart - San Diego",
      customerJson: "",
      location: "Bargain Mart Plaffza, Anytown",
      creationDate: "2016.12.28.18.02.28",
      updateDate: "2016.12.28.18.02.28",
      createdBy: 1
    };
  constructor(public nav: NavController, public navParams: NavParams, private api:Api, private gVLogger: GVLogger) {

  }


  ionViewDidLoad() {
  	this.loadCustomerById(sessionStorage.getItem("customerIdDetail"));
    this.gVLogger.log('ionViewDidLoad CustomerDetailPage');
 this.gVLogger.log(this.customerDetail);

  }


loadCustomerById(customerId){
	var url = "customer/".concat(String(customerId));

    this.gVLogger.log(url);
    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(data => {
       this.customerDetail = data.data;
       this.gVLogger.log(this.customerDetail);
	});
}

goToCart() {
    this.nav.push(CartPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/customer-detail/customer-detail.ts